<template>
  <div class="accessibility-filter-list">
    <filter-option
      v-for="(option, index) in options" :key="index"
      ref="options"
      :option="option" :settings="settings"
      @pref-changed="prefChanged"
    />
  </div>
</template>

<script>
import FilterOption from './AccessibilityFilterOption';

export default {
  name: 'accessibility-filter-list',
  components: {
    FilterOption,
  },
  data() {
    return {
      prefs: {},
    };
  },
  props: {
    options: Array,
    settings: Object,
  },
  methods: {
    prefChanged(name, pref) {
      if (Object.keys(pref).some(key => pref[key] !== null)) {
        this.prefs[name] = pref;
        this.$emit('prefs-changed', this.prefs);
      }
    },
    clear() {
      this.$refs.options.forEach(option => option.clear());
      this.prefs = {};
    },
    report() {
      const clone = JSON.parse(JSON.stringify(this.prefs));
      this.$emit('prefs-changed', clone);
    },
  },
};
</script>

<style scoped>
.accessibility-filter-list {
  margin-bottom: 16px;
}
</style>